
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  BarChart3, 
  Megaphone, 
  DollarSign, 
  Star, 
  MessageCircle, 
  Camera 
} from 'lucide-react';
import { 
  SidebarGroup, 
  SidebarGroupContent, 
  SidebarGroupLabel, 
  SidebarMenu, 
  SidebarMenuItem, 
  SidebarMenuButton 
} from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import ROUTES from '@/routes-map';

const PerformanceGroup: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Performance & Marketing</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.STATISTICS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.STATISTICS}>
                <BarChart3 className="h-5 w-5" />
                <span>Statistics</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.ADS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.ADS}>
                <Megaphone className="h-5 w-5" />
                <span>Advertisements</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.MY_INCOME) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.MY_INCOME}>
                <DollarSign className="h-5 w-5" />
                <span>My Income</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.REVIEWS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.REVIEWS}>
                <Star className="h-5 w-5" />
                <span>Reviews</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.STORIES) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.STORIES}>
                <MessageCircle className="h-5 w-5" />
                <span>Stories</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.BEFORE_AFTER) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.BEFORE_AFTER}>
                <Camera className="h-5 w-5" />
                <span>Before & After Gallery</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

export default PerformanceGroup;
